import { useEffect, useState } from "react";
import {
  PaymentMethodAnimationConfiguration as AnimConfig,
  GlobalConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";
import AmountToWords from "../../_utils/AmountToWords";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import CommonLayout from "../../_utils/CommonLayout";

const FieldForceTransferAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  isNeft,
  setIsNeft,
  isRtgs,
  setIsRtgs,
  setIsImps,
  BenEnableNextButton,
  setShowRupeeSymbol,
  amountInWords,
  setAmountInWords,
  copyData,
  setCopyData,
  selectedValueName,
  setselectedValueName,
  NewAmount,
  setNewAmount,
  type,
  setAmountDisable,
  currentAccountDetails,
  isStepValid,
  RequestAmountWords,
  isRtgsValid,
}) => {
  const [slideAnimation, setSlideAnimation] = useState(false);

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };
  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      setShowRupeeSymbol(false);
      setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");
    const enteredAmount = parseFloat(
      numericValue || GlobalConfiguration.lengthCheckZero,
    );
    const initialAmount = parseFloat(
      NewAmount || GlobalConfiguration.lengthCheckZero,
    );

    if (type === "PayReimburseTxn") {
      if (enteredAmount !== initialAmount) {
        setselectedValueName("customname");
      } else {
        setselectedValueName("username");
      }
    }

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > 0 && amountNumber <= 1
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedAmountWords,
      }));

      setShowRupeeSymbol(numericValue.trim() !== "");
      setAmountInWords(adjustedAmountWords);
    }
  };

  const handleAutofill = () => {
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: NewAmount,
      amountInWords:
        NewAmount > GlobalConfiguration.lengthCheckZero &&
        NewAmount <= GlobalConfiguration.lengthCheckOne
          ? NewAmount.replace("rupees", "rupee")
          : NewAmount,
    }));
  };

  const handleRadioBtn = (event) => {
    setselectedValueName(event.target.value);
    if (event.target.value === "legalname") {
    } else if (event.target.value === "username") {
      handleAutofill();
    }
  };

  const handleDivBtn = (value) => {
    setselectedValueName(value);
    if (value === "legalname") {
    } else if (value === "username") {
      handleAutofill();
    }
  };

  const formattedAmount = (value) => {
    if (value === "" || value === null || value === undefined) {
      return "";
    }
    return Number(value).toFixed(GlobalConfiguration.lengthCheckTwo);
  };

  const isAmountExceeding =
    type === "PayReimburseTxn" &&
    selectedValueName === "customname" &&
    Number(txnPayLoad?.amount) > Number(NewAmount);

  return (
    <>
      <div
        className="w-width-full h-height-full px-padding-md Qlg:px-padding-base overflow-y-auto Qsmd:pt-padding-lg pt-padding-md"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div
            className="w-width-full max-h-auto rounded-border-radius-md bg-primary-card"
            style={{ scrollbarWidth: "none" }}
          >
            {!isStepValid && (
              <>
                <div className=" bg-emphasis flex mb-margin-md rounded-border-radius-md">
                  <div className=" flex p-padding-md  items-center justify-center">
                    <img
                      className="w-icon-md h-icon-md"
                      src="https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                      alt="Error icon"
                    />
                    <p className=" ml-margin-sm text-text-primary text-font-sm font-normal">
                      The transaction amount should not exceed the requested
                      amount.
                    </p>
                  </div>
                </div>
              </>
            )}

            <Amount
              title={TEXT?.TRANSFER_AMOUNT}
              amount={
                type === "PayReimburseTxn" &&
                Number(currentAccountDetails?.amount) ===
                  Number(txnPayLoad?.amount)
                  ? formattedAmount(currentAccountDetails?.amount)
                  : txnPayLoad?.amount
              }
              amountInWords={
                type === "PayReimburseTxn" &&
                currentAccountDetails?.amount === txnPayLoad?.amount
                  ? RequestAmountWords(currentAccountDetails?.amount)
                  : amountInWords
              }
              copyData={copyData}
              onAmountChange={(val) =>
                handleAmountChange({ name: "amount", value: val })
              }
              onPasteApplied={() =>
                setCopyData({ title: "", data_type: "", value: "" })
              }
              isPreview={false}
              handleRadioBtn={handleRadioBtn}
              NewAmount={NewAmount}
              selectedRadioValue={selectedValueName}
              handleDivBtn={(val) => handleDivBtn(val)}
              customAmountRequired={type === "PayReimburseTxn" ? true : false}
              isAmountExceeding={isAmountExceeding}
            />
          </div>
          <PaymentMethodSelector
            title={TEXT?.SELECT_PAYMENT_METHOD}
            slideAnimation={slideAnimation}
            previewMode={false}
            methods={[
              {
                key: "neft",
                label: TEXT?.NEFT,
                subText: TEXT?.NEFT_TRANSFER_NOTE,
                active: isNeft,
                notes: [
                  TEXT?.TRANSACTION_EXECUTION_NOTE,
                  TEXT?.TRANSACTION_LIMIT_NOTE,
                  TEXT?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: () => {
                  if (!isNeft) setSlideAnimation(true);
                  setTimeout(
                    () => setSlideAnimation(false),
                    AnimConfig.slideDuration,
                  );
                  setIsNeft(false);
                  setIsImps(false);
                  setIsRtgs(false);
                  setTxnPayLoad({ ...txnPayLoad, settleType: "neft" });

                  BenEnableNextButton(false);
                },
              },
              {
                key: "rtgs",
                label: TEXT?.RTGS,
                subText: TEXT?.INSTANT_TRANSFER_NOTE,
                active: isRtgs,
                notes: [
                  TEXT?.RTGS_TRANSACTION_EXECUTION_NOTE,
                  TEXT?.RTGS_TRANSACTION_LIMIT_NOTE,
                  TEXT?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: () => {
                  if (!isRtgs) setSlideAnimation(true);
                  setTimeout(
                    () => setSlideAnimation(false),
                    AnimConfig.slideDuration,
                  );
                  setIsNeft(false);
                  setIsImps(false);
                  setIsRtgs(true);
                  setTxnPayLoad({ ...txnPayLoad, settleType: "rtgs" });
                },
              },
            ]}
          />
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
      </div>
    </>
  );
};

export default FieldForceTransferAmount;
